<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()">
  <div class="wrapper--spacing-vertical flex__child--auto">
    <div class="wrapper--spacing-vertical">
      <app-flock-multiline-chart
        *ngIf="
          flockData || breedersReferenceBenchmarkData || porphyrioBenchmarkData || otherFlockData
        "
        [flockData]="flockData"
        [breedersReferenceBenchmarks]="breedersReferenceBenchmarkData"
        [porphyrioBenchmarks]="porphyrioBenchmarkData"
        [otherFlockData]="otherFlockData"
        [otherFlockName]="otherFlockName"
        [kpi]="kpi"
        [flock]="data.flock"
      ></app-flock-multiline-chart>
    </div>
  </div>

  <div class="wrapper--spacing-vertical">
    <agr-extended-notification
      *ngIf="!anyDataSourceIsSelected"
      notificationType="info"
      [title]="
        'flock-overview.week-registrations.benchmark.error.no-data-sources-title' | translate
      "
      [message]="
        'flock-overview.week-registrations.benchmark.error.no-data-sources-description' | translate
      "
    >
    </agr-extended-notification>
  </div>
  <div class="wrapper--spacing-vertical">
    <agr-extended-notification
      *ngIf="anyDataSourceIsSelected && !allSelectedDataSourcesContainsData"
      notificationType="info"
      [title]="'flock-overview.week-registrations.benchmark.error.no-data-title' | translate"
      [message]="dataSourcesWithoutDataDescription"
    >
    </agr-extended-notification>
  </div>
</agr-dialog>
